import React from "react";

import ErrorPage from "components/ErrorPage";

import PageNotFoundImg from "assets/images/page-not-found-img.png";

const NotFound: React.FC = () => {
  return (
    <ErrorPage
      image={PageNotFoundImg}
      message="Вибачте, ця сторінка недоступна"
      subMessage="Можливо посилання за яким ви перейшли не працює або сторінку було видалено."
    />
  );
};

export default NotFound;
